import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  CircularProgress,
  IconButton,
  Badge,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Toolbar } from "@mui/material";
import {
  getScholarshipAppeals,
  getAppealDetails,
  respondToAppeal,
  editAppealResponse,
  getScholarshipSchedule,
  getScholarshipRequest,
  getScholarshipRequestAttachments,
  getScholarshipRequestLogs,
  getScholarshipCombinations,
  getScholarshipCourses,
  getScholarshipDocuments,
} from "../../../../store/scholarship/actions";

import ReactPaginate from "react-paginate";
import moment from "moment";
import AlertDialog from "../../common/components/AlertDialog";
import PreviewTeacherProfile from "../components/PreviewTeacherProfile";
import PreviewScholarshipRequestDialog from "../components/PreviewScholarshipRequestDialog";
import { CSVLink } from "react-csv";
import axios from "axios";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const Appeals = (props) => {
  useEffect(() => {
    document.title = "TMIS | Scholarship Appeals";
  }, []);

  const { hasPermissions } = useRequiredAuth();

  const {
    user,
    loading,
    env,
    scholarshipAppeals,
    getScholarshipAppeals,
    scholarshipSchedule,
    getScholarshipSchedule,
    getScholarshipCombinations,
    getScholarshipCourses,
    getScholarshipDocuments,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
  } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [loader, setLoader] = useState(false);

  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10
  );

  useEffect(() => {
    if (!scholarshipCombinations.length) getScholarshipCombinations();
    if (!scholarshipCourses.length) getScholarshipCourses();
    if (!scholarshipDocuments.length) getScholarshipDocuments();

    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };
    getScholarshipAppeals(query, setTotalRecods, setLoader);

    getScholarshipSchedule();
  }, [user.selectedEntity, user.selectedAcademicYear]);

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };
      getScholarshipAppeals(query, setTotalRecods, setLoader);
    }
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getScholarshipAppeals(query, setTotalRecods, setLoader);
  };

  const [downloadbleData, setDownloadbleData] = useState([]);
  const dispatch = useDispatch();

  const getDownloadbleData = async () => {
    try {
      setDownloadbleData([]);

      dispatch({ type: "START_LOADING" });

      const { data } = await axios.get("/api/scholarship/appeals");

      dispatch({ type: "END_LOADING" });

      setDownloadbleData(data.records || []);
    } catch (error) {
      dispatch({ type: "END_LOADING" });
    }
  };

  useEffect(() => {
    if (!!downloadbleData.length)
      document.getElementById("downloadBTN").click();
  }, [downloadbleData]);

  return (
    <>
      <div className="px-4 pt-2">
        <div className="border rounded">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar
              style={{
                minHeight: "0px",
                borderBottom: "3px solid #e9ecef",
              }}
              className=" my-0 py-1 bg-light"
            >
              <Typography
                variant="p"
                noWrap
                component="div"
                className="d-flex align-items-center text-uppercase text-primary font-weight-bold"
              >
                <span className="text-dark">({totalRecods}) Appeals</span>

                <CSVLink
                  data={downloadbleData}
                  filename={`Scholarship Appeals - ${
                    user?.selectedEntity?.name || ""
                  }.csv`}
                  className="hidden"
                  id="downloadBTN"
                  target="_blank"
                />
                {hasPermissions(["SCHOLARSHIP_APPEAL_DOWNLOAD_EXCEL_FILE"]) && (
                  <Tooltip title="Download">
                    <span className="ml-2">
                      <IconButton
                        size="small"
                        disabled={loading || !scholarshipAppeals?.length}
                        className=" mr-1"
                        color="primary"
                        onClick={() => getDownloadbleData()}
                      >
                        <span className="material-icons">file_download</span>
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Typography>

              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  onSearch={onSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };

                      getScholarshipAppeals(query, setTotalRecods, setLoader);
                    }
                  }}
                  placeholder="Search…"
                />
              </Box>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "0.5rem",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
              height: "59vh",
              overflowY: "auto",
            }}
            className="px-3"
          >
            {Array.isArray(scholarshipAppeals) &&
            scholarshipAppeals.length > 0 ? (
              <table className="table table-striped table-hover fixTableHead">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col" className="text-left">
                      Appeal Date
                    </th>
                    <th scope="col" className="text-left">
                      Applicant
                    </th>
                    <th scope="col" className="text-left">
                      Application
                    </th>
                    <th scope="col" className="text-left">
                      Contact Info
                    </th>
                    {hasPermissions(["SCHOLARSHIP_VIEW_APPEAL_REASON"]) && (
                      <th scope="col" className="text-left">
                        Appeal Reason
                      </th>
                    )}
                    <th scope="col" className="text-center">
                      Decision
                    </th>
                    {hasPermissions(["SCHOLARSHIP_RESPOND_TO_APPEAL"]) && (
                      <th scope="col" className="text-center">
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {scholarshipAppeals.map((appeal, index) => (
                    <ConnectedItemCard
                      key={appeal.id || index}
                      appeal={appeal}
                      user={user}
                      loading={loading}
                      env={env}
                      hasPermissions={hasPermissions}
                    />
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No appeals found"}
                  </p>
                </div>
              </div>
            )}
          </div>
          {Array.isArray(scholarshipAppeals) &&
            scholarshipAppeals.length > 0 && (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ overflow: "hidden" }}
              >
                <>
                  <div className="mt-3">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel={
                        <>
                          <span className="pr-1 d-none d-md-inline">Next</span>
                          <i className="fas fa-angle-double-right"></i>
                        </>
                      }
                      previousLabel={
                        <>
                          <i className="fas fa-angle-double-left"></i>
                          <span className="pl-1 d-none d-md-inline">
                            Previous
                          </span>
                        </>
                      }
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      pageCount={Math.ceil(totalRecods / itemPerPage)}
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                      previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                      nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                      activeLinkClassName="active"
                    />
                  </div>

                  <select
                    className="custom-select custom-select-sm mr-3 ml-2"
                    style={{ width: "100px" }}
                    value={itemPerPage}
                    onChange={(event) => {
                      const itemPerPage = +event.target.value;
                      window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                      setItemPerPage(itemPerPage);
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };
                      getScholarshipAppeals(query, setTotalRecods, setLoader);
                    }}
                  >
                    {[10, 50, 100, 150].map((item, index) => (
                      <option key={index}>{item}</option>
                    ))}
                  </select>
                </>
              </div>
            )}
        </div>
      </div>

      {loader && (
        <CircularProgress
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "rgb(7, 142, 206)",
            position: "absolute",
            top: "42%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
          size={40}
          thickness={4}
        />
      )}
    </>
  );
};

const ItemCard = (props) => {
  const {
    loading,
    user,
    appeal,
    getAppealDetails,
    respondToAppeal,
    editAppealResponse,
    getScholarshipRequest,
    getScholarshipRequestAttachments,
    getScholarshipRequestLogs,
    env,
    hasPermissions,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
  } = props;

  const [appealDetails, setAppealDetails] = useState(null);
  const [showResponseDialog, setShowResponseDialog] = useState(false);
  const [responseText, setResponseText] = useState("");
  const [responseStatus, setResponseStatus] = useState(2);
  const [submitting, setSubmitting] = useState(false);
  const [showReasonDialog, setShowReasonDialog] = useState(false);
  const [appealReasonData, setAppealReasonData] = useState(null); // New state for appeal reason
  const [showPreviewProfileDialog, setShowPreviewProfileDialog] =
    useState(false);
  const [
    showPreviewScholarshipRequestDialog,
    setShowPreviewScholarshipRequestDialog,
  ] = useState(false);
  const [scholarshipRequest, setScholarshipRequest] = useState(null);
  const [showResponseDetailsDialog, setShowResponseDetailsDialog] =
    useState(false);
  const [responseDetailsData, setResponseDetailsData] = useState(null); // New state for response details
  const [showEditResponseDialog, setShowEditResponseDialog] = useState(false);

  const handleOpenResponseDialog = () => {
    setShowResponseDialog(true);
  };

  const handleSubmitResponse = () => {
    if (!responseText.trim()) return;
    setSubmitting(true);

    respondToAppeal(
      appeal.id,
      {
        statusId: responseStatus,
        response: responseText,
      },
      () => {
        setSubmitting(false);
        setShowResponseDialog(false);
      },
      () => {
        setSubmitting(false);
      }
    );
  };

  const handleViewScholarshipRequest = async () => {
    if (appeal.scholarshipRequestId) {
      try {
        setSubmitting(true);
        const data = await getScholarshipRequest(appeal.scholarshipRequestId);
        if (data) {
          setScholarshipRequest(data);
          getScholarshipRequestAttachments(appeal.scholarshipRequestId);
          getScholarshipRequestLogs(appeal.scholarshipRequestId);
          setShowPreviewScholarshipRequestDialog(true);
        }
        setSubmitting(false);
      } catch (error) {
        console.error("Error fetching scholarship request:", error);
        setSubmitting(false);
      }
    }
  };

  const handleViewAppealReason = () => {
    setAppealReasonData(appeal);
    setShowReasonDialog(true);
  };

  const handleViewResponseDetails = () => {
    setResponseDetailsData(appeal);
    setShowResponseDetailsDialog(true);
  };

  const handleEditResponse = () => {
    setResponseText(appeal.response || "");
    setResponseStatus(appeal.statusId);
    setShowEditResponseDialog(true);
  };

  const handleSubmitEditResponse = () => {
    if (!responseText.trim()) return;
    setSubmitting(true);

    editAppealResponse(
      appeal.id,
      {
        statusId: responseStatus,
        response: responseText,
      },
      () => {
        setSubmitting(false);
        setShowEditResponseDialog(false);
      },
      () => {
        setSubmitting(false);
      }
    );
  };

  let statusColor = "secondary";
  if (appeal.statusId === 2) statusColor = "success";
  if (appeal.statusId === 3) statusColor = "danger";

  return (
    <>
      <tr>
        <th scope="row" className="text-left">
          {appeal.no}
        </th>
        <td className="text-left">{moment(appeal.createdOn).format("ll")}</td>

        <td className="text-left">
          <button
            onClick={() => setShowPreviewProfileDialog(true)}
            className="btn btn-link btn-sm px-0 py-0 text-uppercase text-left text-underline font-weight-bold"
          >
            {appeal.lastName} {appeal.firstName}{" "}
            {appeal.createdBy === user.id && (
              <span className="badge badge-primary">Me</span>
            )}
          </button>
          <div>
            {appeal.positionName || "Teacher"} (
            {appeal.qualificationLevelName || "N/A"}) <br />
            <span className="text-primary font-weight-bold">
              @{appeal.schoolName} <i className="fas fa-chevron-right"></i>{" "}
              {appeal.sectorName || "N/A"} / {appeal.districtName || "N/A"}
            </span>
          </div>
        </td>

        <td className="text-left">
          <Button
            size="small"
            variant="outlined"
            color="primary"
            startIcon={<span className="material-icons">description</span>}
            onClick={handleViewScholarshipRequest}
            disabled={submitting}
          >
            Application
          </Button>
        </td>

        <td className="text-left">
          <div>
            <span>{appeal.phoneNumber}</span>
            <br />
            <span>{appeal.email}</span>
          </div>
        </td>

        {hasPermissions(["SCHOLARSHIP_VIEW_APPEAL_REASON"]) && (
          <td className="text-left">
            <div className="d-flex align-items-center">
              <Button
                size="small"
                variant="outlined"
                color="info"
                onClick={handleViewAppealReason}
              >
                <span className="material-icons">visibility</span>
              </Button>
            </div>
          </td>
        )}

        <td className="text-center">
          <span className={`text-uppercase badge badge-${statusColor}`}>
            {appeal.statusName}
          </span>
        </td>

        <td className="text-center">
          {appeal.statusId === 1 &&
            hasPermissions(["SCHOLARSHIP_RESPOND_TO_APPEAL"]) && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleOpenResponseDialog}
                disabled={submitting}
              >
                Respond
              </Button>
            )}
          {appeal.statusId !== 1 && (
            <div className="d-flex justify-content-center">
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleViewResponseDetails}
                startIcon={<span className="material-icons">message</span>}
              >
                Response
              </Button>
              {false && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={handleEditResponse}
                  className="ml-1"
                >
                  <span className="material-icons">edit</span>
                </Button>
              )}
            </div>
          )}
        </td>
      </tr>

      {showReasonDialog && appealReasonData && (
        <AlertDialog
          title="Appeal Reason"
          maxWidth="md"
          showAlert={showReasonDialog}
          setShowAlert={setShowReasonDialog}
        >
          <div className="p-3">
            <div className="row mb-3">
              <div className="col-md-6">
                <h6 className="font-weight-bold">Appeal Date</h6>
                <p>{moment(appealReasonData.createdOn).format("ll")}</p>
              </div>
              <div className="col-md-6">
                <h6 className="font-weight-bold">Applicant</h6>
                <p>
                  {appealReasonData.lastName} {appealReasonData.firstName}
                </p>
              </div>
            </div>

            <div className="mb-3">
              <h6 className="font-weight-bold">Appeal Reason</h6>
              <div className="p-3 bg-light border rounded">
                {appealReasonData.reason || "No reason provided"}
              </div>
            </div>
          </div>
        </AlertDialog>
      )}

      {appealDetails && (
        <AlertDialog
          title="Confirm Appeal Response"
          maxWidth="sm"
          showAlert={
            !!appealDetails && responseText.trim() !== "" && !showResponseDialog
          }
          setShowAlert={() => setAppealDetails(null)}
          actions={
            <div className="d-flex justify-content-end w-100">
              <Button
                color="inherit"
                onClick={() => setAppealDetails(null)}
                disabled={submitting}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setSubmitting(true);
                  respondToAppeal(
                    appeal.id,
                    {
                      statusId: responseStatus,
                      response: responseText,
                    },
                    () => {
                      setSubmitting(false);
                      setShowResponseDialog(false);
                      setAppealDetails(null);
                    },
                    () => {
                      setSubmitting(false);
                    }
                  );
                }}
                disabled={submitting}
                style={{
                  minWidth: "150px",
                  fontWeight: "bold",
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
              >
                {submitting ? (
                  <>
                    <CircularProgress
                      size={20}
                      color="inherit"
                      className="mr-2"
                    />
                    Submitting...
                  </>
                ) : (
                  "Confirm"
                )}
              </Button>
            </div>
          }
        >
          <div className="p-3">
            <div>
              <div className="font-weight-bold mb-3">
                {responseStatus === 2 ? (
                  <span className="text-success">
                    <i className="fas fa-check-circle mr-2"></i>
                    Appeal will be marked as VALID
                  </span>
                ) : (
                  <span className="text-danger">
                    <i className="fas fa-times-circle mr-2"></i>
                    Appeal will be marked as NOT VALID
                  </span>
                )}
              </div>

              <p>
                Applicant{" "}
                <strong>
                  {appeal.firstName} {appeal.lastName}
                </strong>{" "}
                {responseStatus === 2 ? (
                  <span>
                    will be{" "}
                    <strong className="text-success">shortlisted</strong> for
                    the scholarship due to your appeal response.
                  </span>
                ) : (
                  <span>
                    will{" "}
                    <strong className="text-danger">not be shortlisted</strong>{" "}
                    for the scholarship due to your appeal response.
                  </span>
                )}
              </p>

              {responseStatus === 3 && (
                <div className="mt-3">
                  <h6 className="font-weight-bold">
                    Reason for not shortlisting:
                  </h6>
                  <div className="p-3 bg-light border rounded">
                    {responseText}
                  </div>
                </div>
              )}
            </div>
          </div>
        </AlertDialog>
      )}

      {showResponseDialog && (
        <AlertDialog
          title="Respond to Appeal"
          maxWidth="md"
          showAlert={showResponseDialog}
          setShowAlert={(value) => {
            if (!submitting) {
              setShowResponseDialog(value);
            }
          }}
          actions={
            <div className="d-flex justify-content-end w-100">
              <Button
                color="inherit"
                onClick={() => !submitting && setShowResponseDialog(false)}
                disabled={submitting}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => {
                  if (!responseText.trim() || responseText.length > 500) return;
                  setAppealDetails(appeal);
                  setShowResponseDialog(false);
                }}
                disabled={
                  !responseText.trim() ||
                  submitting ||
                  responseText.length > 500
                }
                style={{
                  minWidth: "150px",
                  fontWeight: "bold",
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
              >
                <>
                  <span className="material-icons mr-1">send</span>
                  Submit Response
                </>
              </Button>
            </div>
          }
        >
          <div>
            <div className="mb-3">
              <Typography variant="body2">
                Appeal Date: {moment(appeal.createdOn).format("ll")}
              </Typography>
              <Typography variant="body2">
                Applicant Name: {appeal.lastName} {appeal.firstName}
              </Typography>
              <Typography variant="body2">
                Applicant Phone: {appeal.phoneNumber}
              </Typography>
              <Typography variant="body2">
                Applicant Email: {appeal.email}
              </Typography>
            </div>

            <div className="mb-3">
              <h6 className="font-weight-bold">Appeal Reason</h6>
              <div
                className="p-3 bg-light border rounded"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                {appeal.reason || "No reason provided"}
              </div>
            </div>

            <div className="my-4">
              <div className="form-group">
                <label className="font-weight-bold">Decision</label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="response-status"
                      id="approve-appeal"
                      value="2"
                      checked={responseStatus === 2}
                      onChange={() => setResponseStatus(2)}
                      disabled={submitting}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="approve-appeal"
                    >
                      Valid
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="response-status"
                      id="reject-appeal"
                      value="3"
                      checked={responseStatus === 3}
                      onChange={() => setResponseStatus(3)}
                      disabled={submitting}
                    />
                    <label className="form-check-label" htmlFor="reject-appeal">
                      Not Valid
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <TextField
              autoFocus
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              label="Response"
              placeholder="Enter your response here..."
              value={responseText}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                  setResponseText(e.target.value);
                }
              }}
              inputProps={{
                maxLength: 500,
              }}
              disabled={submitting}
              required
              helperText={`${responseText.length}/500 characters`}
              FormHelperTextProps={{
                style: {
                  textAlign: "right",
                  marginRight: "8px",
                  color:
                    responseText.length >= 450
                      ? responseText.length >= 500
                        ? "red"
                        : "orange"
                      : "inherit",
                },
              }}
            />
          </div>
        </AlertDialog>
      )}

      {showEditResponseDialog && (
        <AlertDialog
          title="Edit Appeal Response"
          maxWidth="md"
          showAlert={showEditResponseDialog}
          setShowAlert={(value) => {
            if (!submitting) {
              setShowEditResponseDialog(value);
            }
          }}
          actions={
            <div className="d-flex justify-content-end w-100">
              <Button
                color="inherit"
                onClick={() => !submitting && setShowEditResponseDialog(false)}
                disabled={submitting}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmitEditResponse}
                disabled={
                  !responseText.trim() ||
                  submitting ||
                  responseText.length > 500
                }
                style={{
                  minWidth: "150px",
                  fontWeight: "bold",
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
              >
                {submitting ? (
                  <>
                    <CircularProgress
                      size={20}
                      color="inherit"
                      className="mr-2"
                    />
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-icons mr-1">save</span>
                    Save Changes
                  </>
                )}
              </Button>
            </div>
          }
        >
          <div>
            <div className="mb-3">
              <Typography variant="body2">
                Appeal Date: {moment(appeal.createdOn).format("ll")}
              </Typography>
              <Typography variant="body2">
                Applicant Name: {appeal.lastName} {appeal.firstName}
              </Typography>
              <Typography variant="body2">
                Applicant Phone: {appeal.phoneNumber}
              </Typography>
              <Typography variant="body2">
                Applicant Email: {appeal.email}
              </Typography>
            </div>

            <div className="mb-3">
              <h6 className="font-weight-bold">Appeal Reason</h6>
              <div
                className="p-3 bg-light border rounded"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                {appeal.reason || "No reason provided"}
              </div>
            </div>

            <div className="my-4">
              <div className="form-group">
                <label className="font-weight-bold">Decision</label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="response-status-edit"
                      id="approve-appeal-edit"
                      value="2"
                      checked={responseStatus === 2}
                      onChange={() => setResponseStatus(2)}
                      disabled={submitting}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="approve-appeal-edit"
                    >
                      Valid
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="response-status-edit"
                      id="reject-appeal-edit"
                      value="3"
                      checked={responseStatus === 3}
                      onChange={() => setResponseStatus(3)}
                      disabled={submitting}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="reject-appeal-edit"
                    >
                      Not Valid
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <TextField
              autoFocus
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              label="Response"
              placeholder="Enter your response here..."
              value={responseText}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                  setResponseText(e.target.value);
                }
              }}
              inputProps={{
                maxLength: 500,
              }}
              disabled={submitting}
              required
              helperText={`${responseText.length}/500 characters`}
              FormHelperTextProps={{
                style: {
                  textAlign: "right",
                  marginRight: "8px",
                  color:
                    responseText.length >= 450
                      ? responseText.length >= 500
                        ? "red"
                        : "orange"
                      : "inherit",
                },
              }}
            />
          </div>
        </AlertDialog>
      )}

      {showResponseDetailsDialog && responseDetailsData && (
        <AlertDialog
          title="Appeal Response"
          maxWidth="md"
          showAlert={showResponseDetailsDialog}
          setShowAlert={setShowResponseDetailsDialog}
        >
          <div className="p-3">
            <div className="row mb-3">
              <div className="col-md-6">
                <h6 className="font-weight-bold">Appeal Information</h6>
                <div className="mb-2">
                  <span className="text-muted">Date Submitted:</span>
                  <br />
                  {moment(responseDetailsData.createdOn).format("ll")}
                </div>
                <div className="mb-2">
                  <span className="text-muted">Submitted By:</span>
                  <br />
                  {responseDetailsData.createdByName}
                </div>
                <div className="mb-2">
                  <span className="text-muted">Decision:</span>
                  <br />
                  <span className={`badge badge-${statusColor}`}>
                    {responseDetailsData.statusName}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <h6 className="font-weight-bold">Response Information</h6>
                <div className="mb-2">
                  <span className="text-muted">Responded On:</span>
                  <br />
                  {responseDetailsData.respondedOn
                    ? moment(responseDetailsData.respondedOn).format("ll")
                    : "Unknown"}
                </div>
                <div className="mb-2">
                  <span className="text-muted">Responded By:</span>
                  <br />
                  {responseDetailsData.respondedByName || "Unknown"}
                </div>
                {responseDetailsData.editedOn && (
                  <div className="mb-2">
                    <span className="text-muted">Last Edited On:</span>
                    <br />
                    {moment(responseDetailsData.editedOn).format("ll")}
                  </div>
                )}
                {responseDetailsData.editedByName && (
                  <div className="mb-2">
                    <span className="text-muted">Last Edited By:</span>
                    <br />
                    {responseDetailsData.editedByName}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-4">
              <h6 className="font-weight-bold">Appeal Reason</h6>
              <div className="p-3 bg-light border rounded">
                {responseDetailsData.reason || "No reason provided"}
              </div>
            </div>

            <div className="mb-3">
              <h6 className="font-weight-bold">Response</h6>
              <div className="p-3 bg-light border rounded">
                {responseDetailsData.response || "No response provided yet"}
              </div>
            </div>
          </div>
        </AlertDialog>
      )}

      {showPreviewProfileDialog && (
        <PreviewTeacherProfile
          showDialog={showPreviewProfileDialog}
          setShowDialog={setShowPreviewProfileDialog}
          teacherId={appeal.createdBy}
        />
      )}

      {showPreviewScholarshipRequestDialog && scholarshipRequest && (
        <PreviewScholarshipRequestDialog
          showDialog={showPreviewScholarshipRequestDialog}
          setShowDialog={setShowPreviewScholarshipRequestDialog}
          request={scholarshipRequest}
        />
      )}
    </>
  );
};

const ConnectedItemCard = connect(
  ({
    loading,
    scholarshipRequestAttachments,
    scholarshipRequestLogs,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
  }) => ({
    loading,
    scholarshipRequestAttachments,
    scholarshipRequestLogs,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
  }),
  {
    getAppealDetails,
    respondToAppeal,
    editAppealResponse,
    getScholarshipRequest,
    getScholarshipRequestAttachments,
    getScholarshipRequestLogs,
  }
)(ItemCard);

const mapStateToProps = ({
  env,
  user,
  loading,
  scholarshipAppeals = [],
  scholarshipSchedule,
  scholarshipCombinations,
  scholarshipCourses,
  scholarshipDocuments,
}) => {
  return {
    env,
    user,
    loading,
    scholarshipAppeals,
    scholarshipSchedule,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
  };
};

export default connect(mapStateToProps, {
  getScholarshipAppeals,
  getAppealDetails,
  respondToAppeal,
  editAppealResponse,
  getScholarshipSchedule,
  getScholarshipRequest,
  getScholarshipRequestAttachments,
  getScholarshipRequestLogs,
  getScholarshipCombinations,
  getScholarshipCourses,
  getScholarshipDocuments,
})(Appeals);
